import { PUBLISH_BLOCK_REASONS } from '../../../../helpers/shopify/resolvePublishMedia';
import localization from '../../../../shared/strings';

const ACTION_STRINGS = localization.DIALOGS.PRODUCT_DIALOGS.STATE_LAYERS.ACTIONS;

/**
 * Tooltip copy for Draft Publish disabled by media readiness (PCS-11014 Bug 4).
 *
 * @param {{ canPublish?: boolean, reason?: string|null, processingCount?: number }} readiness
 * @returns {string|null}
 */
export default function getPublishDisabledMediaTooltip(readiness) {
  if (!readiness || readiness.canPublish !== false || !readiness.reason) {
    return null;
  }

  switch (readiness.reason) {
  case PUBLISH_BLOCK_REASONS.THUMBNAIL_PROCESSING:
    return ACTION_STRINGS.PUBLISH_DISABLED_MEDIA_PROCESSING(
      readiness.processingCount || 1,
    );
  case PUBLISH_BLOCK_REASONS.THUMBNAIL_FAILED:
    return ACTION_STRINGS.PUBLISH_DISABLED_MEDIA_FAILED;
  case PUBLISH_BLOCK_REASONS.THUMBNAIL_MISSING:
    return ACTION_STRINGS.PUBLISH_DISABLED_MEDIA_MISSING;
  case PUBLISH_BLOCK_REASONS.UNSUPPORTED_MEDIA_TYPE:
    return ACTION_STRINGS.PUBLISH_DISABLED_MEDIA_UNSUPPORTED;
  default:
    return null;
  }
}
